import styled from 'styled-components';
import { flexbox, justifyContent, alignItems, flexDirection } from '../../styles/helpers/flexbox';

const Wrapper = styled.div`
    ${flexbox()};
    ${justifyContent('space-between')};

    width: 400px;
`;

const Text = styled.div`
    ${flexbox()};
    ${flexDirection('column')};
    ${alignItems('center')};

    margin-left: 65px;
`;

const Heading = styled.div`
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 15px;
`;

const Description = styled.div`
    font-size: 13px;
    width: 295px;
`;

export {
  Wrapper,
  Text,
  Heading,
  Description
};
